import { parseWidenAssets } from './parse-assets';

let mediaLoadOffset = 0;
let mediaLoadLimit = 25;
let onBatchCallback;
let onCompleteCallback;
let onErrorCallback;
let isLoading = false;

const setOnBatch = (callback) => {
  onBatchCallback = callback;
};

const setOnComplete = (callback) => {
  onCompleteCallback = callback;
};

const setOnError = (callback) => {
  onErrorCallback = callback;
};

const resetLoadState = () => {
  mediaLoadOffset = 0;
  mediaLoadLimit = 25;
  isLoading = false;
  if (!window.MediaGalleryData) {
    window.MediaGalleryData = { mediaItems: [], filters: {} };
  }
  window.MediaGalleryData.mediaItems = [];
};

const fetchGalleryBatch = async () => {
  const { requestUrl, galleryWidenQueryParams } = window;

  if (!requestUrl || !galleryWidenQueryParams) {
    const message = 'Gallery Widen query or request URL is not configured.';
    if (onErrorCallback) {
      onErrorCallback(message);
    }
    return;
  }

  isLoading = true;
  const urlDataParam = `?query=${galleryWidenQueryParams}&limit=${mediaLoadLimit}&offset=${mediaLoadOffset}&expand=file_properties,metadata`;
  const url = `${requestUrl}?data=${encodeURIComponent(urlDataParam)}`;

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });

    if (!response.ok) {
      throw new Error(`Widen proxy returned ${response.status}`);
    }

    const data = await response.json();
    if (data.Error) {
      throw new Error(data.Error);
    }

    const rawItemCount = parseWidenAssets(data);
    const totalCount = parseInt(data.total_count, 10) || 0;

    if (onBatchCallback) {
      onBatchCallback(window.MediaGalleryData.mediaItems.slice());
    }

    mediaLoadOffset += rawItemCount > 0 ? rawItemCount : mediaLoadLimit;

    if (mediaLoadOffset < totalCount && rawItemCount > 0) {
      mediaLoadLimit = 100;
      await fetchGalleryBatch();
      return;
    }

    isLoading = false;
    if (onCompleteCallback) {
      onCompleteCallback(window.MediaGalleryData.mediaItems.slice());
    }
  } catch (error) {
    isLoading = false;
    console.error('Inspiration gallery Widen load failed', error);
    if (onErrorCallback) {
      onErrorCallback(error.message || 'Unable to load gallery images.');
    }
  }
};

const loadGalleryAssets = async () => {
  if (isLoading) {
    return;
  }
  resetLoadState();
  await fetchGalleryBatch();
};

export {
  loadGalleryAssets,
  setOnBatch,
  setOnComplete,
  setOnError,
};
